module.exports = __webpack_public_path__ + "static/media/mamasBirthday.24a1aec7.png";